module.exports = __webpack_public_path__ + "img/wizard5.682d27c3.png";